import { render } from "./pickupReturnRequestRia.vue?vue&type=template&id=013d08e7&scoped=true"
import script from "./pickupReturnRequestRia.vue?vue&type=script&lang=js"
export * from "./pickupReturnRequestRia.vue?vue&type=script&lang=js"

import "./pickupReturnRequestRia.vue?vue&type=style&index=0&id=013d08e7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013d08e7"]])

export default __exports__